// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncidentHistoryForm .h4,
.IncidentHistoryForm label,
.IncidentHistoryForm .IncidentHistoryFormHeader,
.IncidentHistoryForm .IncidentHistoryFormHistoryTitle {
  color: var(--bs-primary);
}
.IncidentHistoryForm .IncidentHistoryFormHeader {
  padding-bottom: 1rem;
}
.IncidentHistoryForm .IncidentHistoryFormHeader > .col {
  display: flex;
  flex-direction: column;
}
.IncidentHistoryForm .IncidentHistoryFormHeader > .col .IncidentHistoryFormTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.IncidentHistoryForm .IncidentHistoryFormLinkTrips {
  padding-bottom: 0.5rem;
}
.IncidentHistoryForm .IncidentHistoryFormLinkTrips > .col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.IncidentHistoryForm .IncidentHistoryFormUpload {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.IncidentHistoryForm .IncidentHistoryFormHistory {
  padding-bottom: 1rem;
}
.IncidentHistoryForm .IncidentHistoryFormHistory .IncidentHistoryFormHistoryTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.IncidentHistoryForm .TextArea[name=description] {
  height: 7rem !important;
  resize: none !important;
}
.IncidentHistoryForm .TextArea[name=crewInfo],
.IncidentHistoryForm .TextArea[name=recoveryInfo],
.IncidentHistoryForm .TextArea[name=medicalAttentionInfo],
.IncidentHistoryForm .TextArea[name=damageInfo],
.IncidentHistoryForm .TextArea[name=witnesses] {
  height: 5rem !important;
  resize: none !important;
}
.IncidentHistoryForm .btn {
  text-transform: uppercase;
}
.IncidentHistoryForm .btn[type=SUBMIT] {
  width: 100%;
  margin: 2rem 0;
}
.IncidentHistoryForm .SimpleTable-Controls {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/features/IncidentHistory/components/IncidentHistoryForm/styles.scss"],"names":[],"mappings":"AACE;;;;EAIE,wBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;AACN;AAAM;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AAER;AAEE;EACE,sBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACN;AAEE;EACE,mBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,uBAAA;EACA,uBAAA;AAAJ;AAEE;;;;;EAKE,uBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AACI;EACE,WAAA;EACA,cAAA;AACN;AAEE;EACE,wBAAA;AAAJ","sourcesContent":[".IncidentHistoryForm {\n  .h4,\n  label,\n  .IncidentHistoryFormHeader,\n  .IncidentHistoryFormHistoryTitle {\n    color: var(--bs-primary);\n  }\n  .IncidentHistoryFormHeader {\n    padding-bottom: 1rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      .IncidentHistoryFormTitle {\n        padding: 0.25rem 0 1rem 0;\n        border-bottom: 1px solid #ccc;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .IncidentHistoryFormLinkTrips {\n    padding-bottom: 0.5rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  .IncidentHistoryFormUpload {\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n  }\n  .IncidentHistoryFormHistory {\n    padding-bottom: 1rem;\n    .IncidentHistoryFormHistoryTitle {\n      padding: 0.25rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .TextArea[name='description'] {\n    height: 7rem !important;\n    resize: none !important;\n  }\n  .TextArea[name='crewInfo'],\n  .TextArea[name='recoveryInfo'],\n  .TextArea[name='medicalAttentionInfo'],\n  .TextArea[name='damageInfo'],\n  .TextArea[name='witnesses'] {\n    height: 5rem !important;\n    resize: none !important;\n  }\n  .btn {\n    text-transform: uppercase;\n    &[type='SUBMIT'] {\n      width: 100%;\n      margin: 2rem 0;\n    }\n  }\n  .SimpleTable-Controls {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
